import { Skeleton } from '@mui/material'

export function AddressSkeleton() {
  return (
    <div className='flex w-full flex-col items-center justify-center'>
      <div className='flex w-[80%] flex-col gap-y-5'>
        <Skeleton
          variant='rounded'
          height={60}
          sx={{ width: '100%', borderRadius: '6px' }}
          animation='pulse'
        />
        <Skeleton
          variant='rounded'
          height={60}
          sx={{ width: '100%', borderRadius: '6px' }}
          animation='pulse'
        />
        <Skeleton
          variant='rounded'
          height={60}
          sx={{ width: '100%', borderRadius: '6px' }}
          animation='pulse'
        />
      </div>
    </div>
  )
}
